import ClientsSlider from "./clientsSlider";
import TestimonialSlider from "./testimonialSlider";
import InstagramFeed from "./instagramFeed";
import ReactGA from "react-ga";
import VerticalGap from "../../components/VerticalGap";
import TopBar from "../../components/TopBar";

import "./index.scss";

const Clients = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div className="clients-page">
      <TopBar heading="Clients" />

      <TestimonialSlider />
      <VerticalGap />
      <ClientsSlider />
      <InstagramFeed />
    </div>
  );
};
export default Clients;
